var AdvancedSettingsType = /*#__PURE__*/function (AdvancedSettingsType) {
  AdvancedSettingsType["FILTER_CONTROL_CHANGE_CLEARS_ALL_FILTERS"] = "filter-control-change-clears-all-filters";
  AdvancedSettingsType["LINK_CHANGE_CLEARS_ALL_FILTERS"] = "link-change-clears-all-filters";
  return AdvancedSettingsType;
}(AdvancedSettingsType || {});
export default AdvancedSettingsType;
//# sourceMappingURL=AdvancedSettingsType.js.map